import { Inject, Injectable } from '@angular/core';
import Intercom, { update } from '@intercom/messenger-js-sdk';
import { InitType, UserArgs } from '@intercom/messenger-js-sdk/dist/types';
import { APP_CONFIG, AppConfig } from '@src/app/app-config.module';
import { NGXLogger } from 'ngx-logger';


@Injectable()
export class IntercomService {

    private readonly testMode: boolean = true;
    private readonly intercomAppId: string;

    constructor(
        private readonly logger: NGXLogger,
        @Inject(APP_CONFIG) private readonly appConfig: AppConfig
    ) {
        this.intercomAppId = appConfig.intercomAppId;
        this.testMode = this.appConfig.intercomTestMode;
    }

    start(startData?: Partial<InitType>) {
        this.logger.debug(`Initializing Intercom with app id: ${this.intercomAppId}`);
        const initData = { app_id: this.intercomAppId, ...startData };
        if (!this.testMode) {
            Intercom(initData);
        }
    }

    update(updateData: UserArgs) {
        this.logger.debug('Updating Intercom with', updateData);
        if (!this.testMode) {
            update(updateData);
        }
    }

}
